/* jshint esnext: true */
/**
 * header
 ***********************/
new Vue({
  el: '#header',
  template: '#header-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/header-prefixes.json",
      jsonPath: './data/header.json'
    },
    style: {},
    prefixied: [],
    picked: {},
    raw: []
  },

  created: function() {
    let _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(data => {
      this.raw = data;
    }).done(() => {
      setPrefix().done(() => {
        var order = getRandomInt(0, _this.raw.length - 1);
        _this.picked = _this.prefixied[order];

        var imgSrc = _this.picked.image;
        _this.style = {
          backgroundImage: 'url(' + imgSrc + ')'
        }
      });
    });

    // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/random
    function getRandomInt(min, max) {
      return Math.floor( Math.random() * (max - min + 1) ) + min;
    }

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, el => {
          var urlPattern = /^https?:\/\//i;
          if (!el.image.match(urlPattern)) {
            el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          }

          if (!el.url.match(urlPattern)) {
            el.url = urlPrefixes.url_before + el.url + urlPrefixes.url_after;
          }

          if (el.subImage && !el.subImage.match(urlPattern)) {
            el.subImage = urlPrefixes.image_before + el.subImage + urlPrefixes.image_after;
          }

          return el;
        });
      });
    }

  }
});

/**
 * header-sub
 ***********************/
new Vue({
  el: '#header-sub',
  template: '#header-sub-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/header-sub-prefixes.json",
      jsonPath: './data/header-sub.json'
    },
    prefixied: [],
    raw: []
  },

  created: function() {
    let _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(data => {
      this.raw = data.slice(0, 6);
    }).done(() => {
      setPrefix();
    });

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, el => {
          var urlPattern = /^https?:\/\//i;
          if (!el.image.match(urlPattern)) {
            el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          }

          return el;
        });
      });
    }

  }
});
